<template>
  <IonModal :is-open="show">
    <IonContent :scroll-y="false" class="ion-padding">
      <IonButton
        style="position: absolute; right: 0; top: calc(var(--ion-safe-area-top, 0) + 0px)"
        fill="clear"
        @click="$emit('onHide')"
      >
        <IonIcon slot="icon-only" :icon="closeOutline" />
      </IonButton>
      <div
        style="
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          height: 100%;
        "
      >
        <h2>{{ $t('FORM-CAPTCHA-VERIFICATION') }}</h2>
        <YandexSmartCaptcha
          :siteKey="clientKey"
          @onSuccess="onSuccessCatcha"
          @onTokenExpired="onTokenExpired"
          :webview="true"
        />
      </div>
    </IonContent>
  </IonModal>
</template>
<script>
import { YandexSmartCaptcha } from '@gladesinger/vue3-yandex-smartcaptcha';
import { IonButton, IonContent, IonIcon, IonModal } from '@ionic/vue';
import { closeOutline } from 'ionicons/icons';
import { mapGetters, mapMutations } from 'vuex';

export default {
  name: 'ModalYandexCaptcha',
  props: ['show'],
  emits: ['onHide'],
  data: () => ({
    closeOutline,
    clientKey: process.env.VUE_APP_YANDEX_SMARTCAPTCHA_CLIENT_KEY
  }),
  computed: {
    ...mapGetters(['error'])
  },
  components: {
    IonContent,
    IonModal,
    YandexSmartCaptcha,
    IonButton,
    IonIcon
  },
  methods: {
    ...mapMutations('user', ['SET_YANDEX_CAPTCHA_TOKEN']),
    onSuccessCatcha(token) {
      this.SET_YANDEX_CAPTCHA_TOKEN(token);
      this.$emit('onHide');
      if (this.error?.onSuccessCatcha) {
        this.error?.onSuccessCatcha();
      }
    }
  }
};
</script>
